<template>

  <div class="service_form_details">
    <b-row class="content-header">
      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="4"
        lg="4"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              {{ agentDetail.code }} - {{ agentDetail.name }}
            </h1>
            <p class="log_info">
              Created by {{ getCreatedBy() }} on {{ getCreatedAt() }}<br>Last updated on {{ getUpdatedAt() }}
            </p>
          </b-col>
        </b-row>
      </b-col>

      <!-- Content Right -->
      <b-col
        class="content-header-right text-md-right mb-1"
        md="8"
        lg="8"
        cols="12"
      >
        <b-button
          v-if="canViewThisAction('update', 'Agent')"
          variant="light"
          class="text-primary"
          :to="{ name: 'agency-agents-probationary-edit', params: { id: agentDetail._id || 0 } }"
        >
          <feather-icon
            icon="EditIcon"
            size="16"
          />
          Edit
        </b-button>
      </b-col>
    </b-row>

    <b-card class="agent__details">
      <b-row>
        <b-col md="12">
          <b-card class="has-padding">
            <b-card-title>
              Probationary Agent Details
            </b-card-title>
            <b-card-body>
              <b-row>
                <b-col
                  md="2"
                  class="d-flex align-self-center"
                >
                  <b-avatar
                    size="150"
                    :src="agentDetail.image"
                    :text="resolveAcronymName(agentDetail.name)"
                  />
                </b-col>
                <b-col md="5">
                  <b-table-simple
                    borderless
                    responsive
                    class="particulars_of_deceased d-none d-md-block"
                  >
                    <b-tbody>
                      <b-tr>
                        <b-th width="230px">
                          Agent Name
                        </b-th>
                        <b-td>{{ agentDetail.name || '-' }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Card Display Name
                        </b-th>
                        <b-td>{{ agentDetail.displayName || '-' }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Agent Code
                        </b-th>
                        <b-td>{{ agentDetail.code || '-' }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Agency
                        </b-th>
                        <b-td>
                          <span v-if="agentDetail.agent">{{ `${agentDetail.agent.agencyName || '-'} (${agentDetail.agent.agencyCode || '-'}) - ${agentDetail.agent.agencyState || '-'}` }}</span>
                          <span v-else>-</span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Agent (Upline)
                        </b-th>
                        <b-td>
                          <span v-if="agentDetail.agent">{{ agentDetail.agent.name }} ({{ agentDetail.agent.code }})</span>
                          <span v-else>-</span>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-col>
                <b-col md="5">
                  <b-table-simple
                    borderless
                    responsive
                    class="particulars_of_deceased d-none d-md-block"
                  >
                    <b-tbody>
                      <b-tr>
                        <b-th width="230px">
                          Join Date
                        </b-th>
                        <b-td>{{ agentDetail.joinDate ? dateFormat(agentDetail.joinDate) : '-' }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Confirm Date
                        </b-th>
                        <b-td>{{ agentDetail.confirmDate ? dateFormat(agentDetail.confirmDate) : '-' }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Expiry Date
                        </b-th>
                        <b-td>{{ agentDetail.expDate ? dateFormat(agentDetail.expDate) : '-' }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Status
                        </b-th>
                        <b-td><span :class="agentDetail.status == 'Active' ? 'text-success' : 'text-danger'">{{ agentDetail.status }}</span></b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="230px">
                          Remarks
                        </b-th>
                        <b-td>{{ agentDetail.remark || '-' }}</b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="match-height">
        <b-col md="4">
          <b-card class="has-padding">
            <b-card-title>
              Personal Information
            </b-card-title>
            <b-card-body>
              <b-table-simple
                borderless
                responsive
                class="particulars_of_deceased d-md-block"
              >
                <b-tbody>
                  <b-tr>
                    <b-th width="120px">
                      NRIC
                    </b-th>
                    <b-td>
                      <div v-if="showFullNric">
                        <span class="mr-50">{{ agentDetail.nric }}</span>
                        <b-button
                          variant="primary"
                          size="sm"
                          class="px-50"
                          @click="showFullNric = false"
                        >
                          Hide full NRIC
                        </b-button>
                      </div>
                      <div v-else>
                        <span class="mr-50">{{ agentDetail.encryptedNric }}</span>
                        <b-button
                          v-if="canViewThisAction('view-nric', 'NRIC')"
                          variant="primary"
                          size="sm"
                          class="px-50"
                          @click="showFullNric = true"
                        >
                          Show full NRIC
                        </b-button>
                      </div>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="120px">
                      Sex
                    </b-th>
                    <b-td>{{ agentDetail.sex || '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="120px">
                      Race
                    </b-th>
                    <b-td>{{ agentDetail.race || '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="120px">
                      Marital
                    </b-th>
                    <b-td>{{ agentDetail.maritalStatus || '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="120px">
                      Date of Birth
                    </b-th>
                    <b-td>{{ agentDetail.dob ? dateFormat(agentDetail.dob) : '-' }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col md="4">
          <b-card class="has-padding">
            <b-card-title>
              Correspondence Contact
            </b-card-title>
            <b-card-body>
              <b-table-simple
                borderless
                responsive
                class="particulars_of_deceased d-md-block"
              >
                <b-tbody>
                  <b-tr>
                    <b-th width="230px">
                      Primary Contact
                    </b-th>
                    <b-td>{{ agentDetail.contact || '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Secondary Contact
                    </b-th>
                    <b-td>{{ agentDetail.homeContact || '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Email Address
                    </b-th>
                    <b-td>{{ agentDetail.email || '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Address
                    </b-th>
                    <b-td>{{ `${agentDetail.address1 || '-'}, ${agentDetail.address2 || '-'}` }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Post Code
                    </b-th>
                    <b-td>{{ agentDetail.postCode || '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Country Code
                    </b-th>
                    <b-td>{{ agentDetail.country || '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      State Code
                    </b-th>
                    <b-td>{{ agentDetail.state || '-' }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col md="4">
          <b-card class="has-padding">
            <b-card-title>
              Emergency Contact
            </b-card-title>
            <b-card-body>
              <b-table-simple
                borderless
                responsive
                class="particulars_of_deceased d-md-block"
              >
                <b-tbody>
                  <b-tr>
                    <b-th width="230px">
                      Emergency Contact Person
                    </b-th>
                    <b-td>{{ agentDetail.emergencyContactName || '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Mobile No.
                    </b-th>
                    <b-td>{{ agentDetail.emergencyContactMobile || '-' }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Relationship
                    </b-th>
                    <b-td>{{ agentDetail.emergencyContactRelation || '-' }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-card-body>
          </b-card>
          <b-card class="has-padding">
            <b-card-title>
              Bank Details
            </b-card-title>
            <b-card-body>
              <b-table-simple
                borderless
                responsive
                class="particulars_of_deceased d-md-block"
              >
                <b-tbody>
                  <b-tr>
                    <b-th width="230px">
                      Bank Code
                    </b-th>
                    <b-td>{{ agentDetail.bankCode }} - {{ agentDetail.bankName }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Bank Branch
                    </b-th>
                    <b-td>{{ agentDetail.bankBranch }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th width="230px">
                      Bank Account No.
                    </b-th>
                    <b-td>{{ agentDetail.bankAccountNo }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-card
            title="Attachments"
            class="has-padding"
          >
            <input
              ref="hiddenAllocationFileInput"
              type="file"
              multiple
              capture
              accept="image/jpeg, image/png, application/pdf"
              class="d-none"
              @change="setAttachment"
            >
            <b-row v-if="agentAttachments.length">
              <b-col
                v-for="(file, key) in agentAttachments"
                :key="key"
                class="content-header-left mb-2"
                cols="12"
                md="4"
              >
                <div class="attachment-item">
                  <b-img
                    v-if="file.type.includes('image')"
                    left
                    height="40"
                    :src="require('@/assets/images/admin/doc_jpg.png')"
                    alt="Left image"
                  />
                  <b-img
                    v-if="file.type.includes('application')"
                    left
                    height="40"
                    :src="require('@/assets/images/admin/doc_file.png')"
                    alt="Left image"
                  />
                  <strong>
                    <b-link
                      v-if="file.fileStorage"
                      :to="{ name: 'file-view', params: { id: file.fileStorage } }"
                      target="_blank"
                    >
                      {{ file ? file.name : '' }}
                    </b-link>
                    <b-link
                      v-else-if="file.data"
                      :href="file ? file.data : ''"
                      target="_blank"
                    >
                      {{ file ? file.name : '' }}
                    </b-link>
                  </strong>
                  <span>{{ file ? `${file.size}mb` : '' }}</span>
                  <span class="remove__doc">
                    <b-button
                      variant="flat-primary"
                      @click="removeAttachment(file.name, file._id)"
                    >
                      <feather-icon
                        icon="XIcon"
                        class="mr-50"
                        size="18"
                      />
                    </b-button>
                  </span>
                </div>
                <div class="doc__desc new_design">
                  <span v-if="file.description">
                    {{ file.description }}
                  </span>
                  <span v-else>
                    <button @click="updateDescription(key)">
                      Add a description
                    </button>
                  </span>
                  <span
                    v-if="file.description"
                    class="edit__desc"
                  >
                    <b-button
                      variant="flat-primary"
                      @click="updateDescription(key)"
                    >
                      <feather-icon
                        icon="EditIcon"
                        class="mr-50"
                        size="18"
                      />
                    </b-button>
                  </span>
                </div>
              </b-col>
              <b-col
                class="content-header-left mb-2"
                cols="12"
                md="4"
              >
                <b-button
                  variant="link"
                  class="mr-1 md-mb-1"
                  @click="$refs.hiddenAllocationFileInput.click()"
                >
                  <feather-icon
                    icon="UploadIcon"
                    size="20"
                    class="mr-50"
                  />
                  <span
                    class="align-middle"
                    style="font-weight: 500; font-size: 14px;"
                  >
                    Upload
                  </span>
                </b-button>
                <b-button
                  v-if="pendingAttachments.length"
                  variant="success"
                  class="mr-1 md-mb-1"
                  @click="uploadFile"
                >
                  Save File
                </b-button>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col>
                <div class="empty_block">
                  <h4>Nothing in here yet</h4>
                  <b-button
                    variant="link"
                    class=""
                    @click="$refs.hiddenAllocationFileInput.click()"
                  >
                    <feather-icon
                      icon="UploadIcon"
                      size="20"
                      class="mr-50"
                    />
                    <span
                      class="align-middle"
                      style="font-weight: 500; font-size: 14px;"
                    >
                      Upload
                    </span>
                  </b-button>
                  <b-button
                    v-if="pendingAttachments.length"
                    variant="success"
                    class="mr-1 md-mb-1"
                    @click="uploadFile"
                  >
                    Save File
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-card>

    <b-card class="mb-3 mt-3 p-2">
      <b-row class="content-header">
        <b-col
          class="content-header-left pb-2"
          cols="12"
          md="12"
        >
          <h4>
            <feather-icon
              icon="ListIcon"
              class="mr-50"
              size="16"
            />
            <span class="align-middle">Activity Logs</span>
          </h4>
        </b-col>
      </b-row>
      <app-timeline>
        <app-timeline-item
          v-for="(opt, key) in agentDetailActivityLogs"
          :key="key"
          :variant="getVariant(key)"
        >
          <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
            <h6>{{ opt.title }}</h6>
            <small class="text-muted">{{ dateFormatWithTime(opt.time) }}</small>
          </div>
        </app-timeline-item>
      </app-timeline>
    </b-card>

    <b-modal
      id="modal-probationary-attachment-description"
      size="lg"
      title="Attachment Description"
      modal-class="status-update-modal"
      centered
      no-stacking
      header-class="front-modal"
      @ok="saveDescription"
      @cancel="closeDescriptionModal"
    >
      <b-row>
        <b-col md="12">
          <b-form-textarea
            id="h-attachment-description"
            v-model="description"
            placeholder="E.g. Payment Schedule"
          />
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="flat-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="!description || attachmentKey === ''"
          @click="ok()"
        >
          <span class="align-middle">Save</span>
        </b-button>
      </template>
    </b-modal>
  </div>

</template>

<script>
import {
  BCard, BCardBody, BRow, BButton, BCol, BTableSimple, BTbody, BTr, BTh, BTd, BAvatar, BCardTitle,
  BImg, BLink, BFormTextarea, BModal,
} from 'bootstrap-vue'
import store from '@/store/index'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BButton,
    BCol,
    BTableSimple,
    BTbody,
    BTr,
    BTh,
    BTd,
    BAvatar,
    BCardTitle,
    BImg,
    BLink,
    BFormTextarea,
    BModal,
    AppTimeline,
    AppTimelineItem,
  },
  data() {
    return {
      canViewThisAction,
      showFullNric: false,
      agentDetail: {},
      agentAttachments: [],
      pendingAttachments: [],
      agentDetailActivityLogs: [],
      description: '',
      attachmentKey: '',
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.fetchAgentDetail()
  },
  methods: {
    resolveAcronymName(name) {
      if (name) {
        return name.split(' ').map(item => item.charAt(0)).join('').toUpperCase()
      }

      return ''
    },
    getCreatedAt() {
      if (this.agentDetail.createdAt) {
        return this.dateFormatWithFormatNTZ(this.agentDetail.createdAt, 'DD/MM/YYYY, hh:mma ')
      }

      return ''
    },
    getCreatedBy() {
      if (this.agentDetail.createdByNvs) {
        return this.agentDetail.createdByNvs.name
      }

      return ''
    },
    getUpdatedAt() {
      if (this.agentDetail.updatedAtNvs) {
        return this.dateFormatWithTime(this.agentDetail.updatedAtNvs)
      }
      if (this.agentDetail.updatedAt) {
        return this.dateFormatWithFormatNTZ(this.agentDetail.updatedAt, 'DD/MM/YYYY, hh:mma ')
      }

      return ''
    },
    getVariant(key) {
      if (key % 4 === 0) return 'info'
      if (key % 4 === 1) return 'warning'
      if (key % 4 === 2) return 'danger'
      if (key % 4 === 3) return 'purple'
      return 'primary'
    },
    fetchAgentDetail() {
      this.$http.get(`customer/agents/probationary/${this.$route.params.id}/show`)
        .then(response => {
          this.agentDetail = response.data.agent
          this.agentAttachments = this.agentDetail.attachments.filter(file => file.fileStorage)
          this.agentDetailActivityLogs = (this.agentDetail.activityLog || []).sort((a, b) => new Date(b.time) - new Date(a.time))
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: (error.data && error.data.message) || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    removeAttachment(name, id) {
      this.$http
        .post('customer/agents/probationary/attachment/remove', { id, name, agentID: this.$route.params.id })
        .then(response => {
          this.agentAttachments = response.data.data.attachments.filter(file => file.fileStorage)
          this.agentDetailActivityLogs = response.data.data.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: (error.data && error.data.message) || '',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    setAttachment(e) {
      if (e.target.files.length) {
        const acceptedTypes = ['image/jpeg', 'image/png', 'application/pdf']
        e.target.files.forEach(element => {
          if (acceptedTypes.includes(element.type)) {
            if (element.size > 20 * 1024 * 1024) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Can't add files more than 20mb",
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            } else {
              const fileObj = {}
              fileObj.name = element.name
              fileObj.data = element
              fileObj.size = (element.size / (1024 * 1024)).toFixed(2)
              fileObj.type = element.type
              fileObj.description = ''
              fileObj.storage = 'local'
              this.pendingAttachments.push(fileObj)
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Unsupported file type',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
      }
    },
    async uploadFile() {
      store.commit('appConfig/UPDATE_CONTINUOUS_LOADER', true)
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.pendingAttachments.length; i++) {
        // eslint-disable-next-line no-await-in-loop
        const res = await this.uploadFileToAws(this.pendingAttachments[i].data)
        const { fileUrl, fileName, upload } = res
        const formData = new FormData()
        if (upload && fileUrl) {
          this.pendingAttachments[i].data = fileName
          this.pendingAttachments[i].storage = 'aws'
          formData.append('sAttachments', JSON.stringify([this.pendingAttachments[i]]))
        } else {
          formData.append('attachments', this.pendingAttachments[i].data)
        }

        formData.append('shouldUpload', (upload && fileUrl))
        formData.append('id', this.agentDetail._id)

        if (i === this.pendingAttachments.length - 1) {
          store.commit('appConfig/UPDATE_CONTINUOUS_LOADER', false)
        }

        this.$http.post('customer/agents/probationary/attachment/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then(response => {
            this.agentAttachments = response.data.data.attachments.filter(file => file.fileStorage)
            this.agentDetailActivityLogs = response.data.data.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'success',
              },
            })
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: (error.data && error.data.message) || '',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
      }

      this.pendingAttachments = []
    },
    closeDescriptionModal() {
      this.$root.$emit('bv::hide::modal', 'modal-probationary-attachment-description', '')
    },
    updateDescription(key) {
      this.attachmentKey = key
      this.description = this.agentAttachments[key].description
      this.$root.$emit('bv::show::modal', 'modal-probationary-attachment-description', '')
    },
    saveDescription() {
      const id = this.agentAttachments[this.attachmentKey]._id
      this.$http
        .post('customer/agents/probationary/attachment/save-description', { id, description: this.description, agentID: this.agentDetail._id })
        .then(response => {
          this.agentAttachments = response.data.data.attachments.filter(file => file.fileStorage)
          this.closeDescriptionModal()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: (error.data && error.data.message) || '',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>

<style lang="scss">
  @import "~@core/scss/base/pages/app-email.scss";
  .agent__details{
       background-color: #F8F8F8;
  }
</style>
